import { SvgIcon } from '@mui/material';

export default function VehicleIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 29 20" style={{ ...props.style, height: `14px` }}>
      <path d="M28.69,9.22l-3.6-6.98c-.67-1.29-2.01-2.09-3.49-2.09H3.02C1.49.15.25,1.36.25,2.85v12.1c0,.88.73,1.6,1.64,1.6h.91c.25,1.86,1.88,3.3,3.86,3.3s3.6-1.44,3.86-3.3h5.92c.25,1.86,1.88,3.3,3.86,3.3s3.6-1.44,3.86-3.3h2.96c.9,0,1.64-.72,1.64-1.6v-5.5c0-.08-.02-.16-.06-.23ZM6.65,18.85c-1.6,0-2.91-1.26-2.91-2.8s1.31-2.8,2.91-2.8,2.91,1.26,2.91,2.8-1.31,2.8-2.91,2.8ZM17.04,7.57H1.52V2.54c0-.61.49-1.1,1.1-1.1h14.42v6.13ZM20.29,18.85c-1.6,0-2.91-1.26-2.91-2.8,0,0,0,0,0,0,0-1.35,1-2.48,2.32-2.74.19-.04.39-.06.59-.06,1.6,0,2.91,1.26,2.91,2.8s-1.31,2.8-2.91,2.8ZM18.56,7.57V1.43h2.66c2.12,0,2.54.99,3.17,2.21.99,1.92,1.51,2.92,2.02,3.93h-7.85Z" />
    </SvgIcon>
  );
}
